import { LanguageEnum } from "../enums/language.enum";

export class UserProfile {
    userName: string;
    fullName: string;
    companyName: string;
    phoneNumber: string;
    phoneNumberConfirmed?: boolean | null;
    jobTitle: string;
    timeZoneId: string;
    temperatureUnitId: number;
    pmUnitId: number;
    showMap: boolean;
    notificationPreferences: number[];
    defaultMapLocation: string;
    twoFactorEnabled: boolean;
    roleRequiresMfa: boolean;
    datePreference: number;
    timePreference: number;
    gasUnit: number;
    windSpeedUnit: number;
    rainfallUnit: number;
    flowRateUnit: number;
    languagePreference: LanguageEnum;
    isSidebarPinned: boolean;
    isAiAnalystEnabled: boolean;
}

export type UserProfilePatch = Partial<Pick<UserProfile, 'jobTitle' | 'phoneNumber' | 'timeZoneId'>>;
